module.exports = __webpack_public_path__ + "img/icon01.aaa97d3b.png";